import React, { Component } from 'react';
import './styles.scss';
import ProductCard from '../ProductCard';

export default class ProductList extends Component {
  products = [
    {
      id: '1',
      name: 'Бордовое базовое худи с флисом',
      img: 'https://images.ua.prom.st/1616027834_w640_h640_bryuki-muzhskie-yoshimitsu.jpg'
    },
    {
      id: '2',
      name: 'Желто-черная худи с белым вставками с флисом',
      img: 'https://oxxxyshop.com/wa-data/public/shop/products/08/01/108/images/487/487.750@2x.jpg'
    }
  ];

  render() {
    return (
      <div className="product-list">
        {this.products.map(product => <ProductCard product={product} key={product.id}/>)}
      </div>
    );
  }
}
